import { render, staticRenderFns } from "./send-form.vue?vue&type=template&id=2eed8f2d&scoped=true"
import script from "./send-form.vue?vue&type=script&lang=js"
export * from "./send-form.vue?vue&type=script&lang=js"
import style0 from "./send-form.vue?vue&type=style&index=0&id=2eed8f2d&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eed8f2d",
  null
  
)

export default component.exports